import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { OwlOptions, SlidesOutputData } from 'ngx-owl-carousel-o';
import { Router } from '@angular/router';
import { first } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';

import {
  GuidedTourService,
  Orientation,
  GuidedTour,
} from "ngx-guided-tour";
import { OnboardingSteps } from 'src/app/core/constants';
import { BaniPost } from 'src/app/core/models';
import { DashboardService } from 'src/app/services/dashboard.service';
import { UtilsService } from 'src/app/services/utils.service';
import { ModalVideoComponent } from '../components';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit{

  isHandsetPortrait: boolean = false;
  @ViewChild('sidenav') sidenavElement: MatDrawer | undefined;
  private readonly TOUR: GuidedTour = {
    tourId: "purchases-tour",
    useOrb: false,
    skipCallback: () => '',
    completeCallback: () => 
      window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    }),
    steps:[]
  };
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    autoplay: true,
    autoplayTimeout:10000,
    touchDrag: true,
    pullDrag: false,
    autoHeight: false,
    dots: false,
    navSpeed: 800,
    smartSpeed: 1800,
    navText: ['&#8249', '&#8250;'],
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      760: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
    nav: false,
  };
  activeSlides: SlidesOutputData | undefined;
  recentReleases: BaniPost[] = [];
  isRecentPostsLoading: boolean = false;
  textParam: any = {};

  constructor(
    private guidedTourService: GuidedTourService,
    private router: Router,
    private dashboardService: DashboardService,
    private utils: UtilsService,
    public dialog: MatDialog,
  ) {

   }

  ngOnInit(): void {
    this.fetchRecentItems();
      
    if(sessionStorage.getItem('url')){
      this.startTour();
      sessionStorage.removeItem('url');
    }
  }
  
  goToSearch() {
    this.router.navigate(['/search']);
  }

  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
    setTimeout(() => {
      this.customOptions = { ...this.customOptions };
      this.guidedSteps()
    }, 200);
  }
  guidedSteps(){
    let currentLanguage = localStorage.getItem('language');
    if (currentLanguage) {
      let onboardingSteps = currentLanguage === 'en' ? OnboardingSteps.en : OnboardingSteps.pa;
      // console.log(this.isHandsetPortrait)
      if(!this.isHandsetPortrait){
      this.TOUR.steps = [
        {
          content: onboardingSteps[0]
        },
        {
          selector: "#searchIcon",
          content: onboardingSteps[1],
          orientation: Orientation.BottomRight,
        },
        {
          selector: "#GuruSahib",
          content: onboardingSteps[2],
          orientation: Orientation.Bottom
        },
        {
          content: onboardingSteps[3],
          selector: "#language",
          orientation: Orientation.BottomRight
        },
        {
          selector: "#project",
          content: onboardingSteps[4],
          orientation: Orientation.Bottom
        },
        {
          selector: "#contact-us",
          content: onboardingSteps[5],
          orientation: Orientation.Top
        },
        {
          content: onboardingSteps[6]
        }
      ]
    }
    else{
      this.TOUR.steps = [
        {
          content: onboardingSteps[0],
        },
        {
          selector: "#searchIcon",
          content: onboardingSteps[1],
          orientation: Orientation.BottomRight,
          action: () => this.sidenavElement?.toggle(),
        },
        {
          selector: "#GuruSahibHandset",
          content: onboardingSteps[2],
          orientation: Orientation.Bottom,
        },
        {
          content: onboardingSteps[3],
          selector:"#languageHandset",
          orientation: Orientation.Bottom
        },
        {
          selector: "#projectHandset",
          content: onboardingSteps[4],
          orientation: Orientation.Bottom
        },
        {
          action: () => this.sidenavElement?.toggle(),
          selector: "#contact-us",
          content: onboardingSteps[5],
          orientation: Orientation.Top
        },
        {
          content: onboardingSteps[6]
        }
      ]
    }
    }
  }
  
  startTour(){
    setTimeout(() => this.guidedTourService.startTour(this.TOUR), 1000);
  }

  getPassedData(data: SlidesOutputData) {
    this.activeSlides = data;
  }
  parseAsString(idString: number): string {
    return String(idString);
  }
  goToPost(baniCode: string) {
    this.router.navigate(['/bani', baniCode]);
  }

  showSmallerString(descriptionText: string) {
    if (descriptionText) {
      let text = this.utils.stripHTML(descriptionText);
      let result = text.substring(0, 102).lastIndexOf(" ");
      return text.substring(0, result);
    } else {
      return descriptionText;
    }
  }
  
  fetchRecentItems() {
    this.isRecentPostsLoading = true;
    this.dashboardService
      .fetchRecentItems()
      .pipe(first())
      .subscribe({
        next: (res: any) => {
          this.isRecentPostsLoading = false;
          this.recentReleases = res?.value?.length ? res.value : [];
        },
        error: (e: any) => {
          this.recentReleases = [];
          // console.error('error in fetching recent carousel items', e);
        },
      });
  }

  /**
   * If BaniVideoURL comes from the backend then use custom logic to extract
   * the thumbnail else return a placeholder
   */
  fetchImageThumbnail(baniItem: any) {
    return baniItem.BaniVideoURL
      ? this.utils.fetchImageThumbnail(baniItem.BaniVideoURL) : (baniItem.BaniImageURL?.trim() ? baniItem.BaniImageURL : '/assets/images/mediaPlaceholder.webp')
  }

  openVideoPopup(details: any): void {
    if (details?.BaniVideoURL) {
      this.dialog.open(ModalVideoComponent, {
        data: { videoURL:details.BaniVideoURL },
      });
    }
    else{
       this.goToPost(details?.BaniCode)
    }
  }
}
